export default "/images/vendor/geoportal-extensions-openlayers/src/OpenLayers/CSS/Controls/Export/GPexportSave.svg?3b645439cf31d49aeffae9fe50c7abb6";